import { Col, Divider, Input, Pagination, Row } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import AddEditFormPlant from 'components/Common/Modal/AddEditFormPlant';
import { selectUserInfo } from 'components/Layout/homeSlice';
import { plantActions, selectPlantList } from 'features/Plant/plantSlice';
import * as React from 'react';
import { FaSearch } from 'react-icons/fa';
import { FiPlus } from 'react-icons/fi';
import PlantInfo from '../../../../components/Common/PlantInfo/PlantInfo';
import style from '../Components.module.scss';
import ItemPlantList from '../ItemPlantList/ItemPlantList';
export interface PlantsProps {}

export default function Plants(props: PlantsProps) {
  const dispatch = useAppDispatch();
  const userInfo = useAppSelector(selectUserInfo);
  const plantList = useAppSelector(selectPlantList);
  const [pagePlant, setPagePlant] = React.useState<number>(0);
  // const [isEvent, setIsEvent] = React.useState<boolean>(false);
  const isEvent: boolean = false;
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [isShowPlantDetail, setIsShowPlantDetail] = React.useState(true);

  React.useEffect(() => {
    if (userInfo !== undefined) {
      dispatch(
        plantActions.fetchPlantList({ id: userInfo.id, text: null, page_size: 10, page: 0 })
      );
    }
  }, [dispatch, userInfo]);

  const onChangeValue = (e: any) => {
    const val = e.target.value;
    dispatch(plantActions.fetchPlantList({ id: null, text: val, page_size: 10, page: 0 }));
  };

  const onChangePage = (page: number) => {
    setPagePlant(page - 1);
  };
  return (
    <>
      {isShowPlantDetail ? (
        <Row className={style.root}>
          <Row className={style.header_info}>
            <Divider orientation="left" plain style={{ fontWeight: 'bold' }}>
              List of Plant
            </Divider>
          </Row>
          <Row className={style.main}>
            <Row className={style.header_main}>
              <Input
                onPressEnter={(e) => onChangeValue(e)}
                size="large"
                placeholder="Search by label"
                prefix={<FaSearch />}
                className={style.search_header}
              />
              <FiPlus
                onClick={() => {
                  setIsModalVisible(!isModalVisible);
                }}
                className={style.btn_create}
                size={20}
              />
            </Row>
            <div className={style.main_table}>
              <Row className={style.header_table}>
                <Col className={style.item_header} span={4}>
                  CODE
                </Col>
                <Col className={style.item_header} span={8}>
                  LABEL
                </Col>
                <Col className={style.item_header} span={5}>
                  SYSTEM SIZE
                </Col>
                <Col className={style.item_header} span={7}>
                  INSTALLED DATE
                </Col>
              </Row>
              <div className={style.content_table} id={style.style_4}>
                {plantList?.map((item, index) => {
                  return (
                    index >= pagePlant * 10 &&
                    index < (pagePlant + 1) * 10 && (
                      <ItemPlantList
                        key={item.id}
                        item={item}
                        setIsShowPlantDetail={setIsShowPlantDetail}
                      />
                    )
                  );
                })}
              </div>
            </div>
          </Row>
          <Row className={style.footer_list}>
            <Pagination
              size="small"
              pageSize={10}
              defaultCurrent={pagePlant + 1}
              total={plantList.length}
              onChange={onChangePage}
              showSizeChanger={false}
              showQuickJumper={false}
            />
          </Row>
        </Row>
      ) : (
        <PlantInfo
          isShowPlantDetail={isShowPlantDetail}
          setIsShowPlantDetail={setIsShowPlantDetail}
        />
      )}
      <AddEditFormPlant
        isEvent={isEvent}
        itemPlant={undefined}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      />
    </>
  );
}
